import { default as ReactSelectAsync } from "react-select/async";

import { useReactSelectConfigProps } from "./reactSelectUtils";

// This is a wrapper component around react-select's AsyncSelect component to ensure that
// accessibility and translation configurations are always used in every AsyncSelect
// that are present in the app.
//
const AsyncSelect = props => {
  const reactSelectConfigProps = useReactSelectConfigProps();

  return <ReactSelectAsync {...reactSelectConfigProps} {...props} />;
};

export default AsyncSelect;
